import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material";


export default function TextCard({ textcard, textcard2 }) {

    const theme = useTheme();
   
    return (
                    
          <Typography variant="body1" sx={{color: theme.palette.mode === "light" ? 'common.black' : 'common.white', fontWeight: 400 }}>
              {textcard}  {textcard2}  
          </Typography>

 );
}